import clsx from "clsx";
import React, { useState } from "react";
import { Confirm } from ".";
import { variants } from "./props";
import { loadingVariants } from "./props/variants";

const sizes = {
  sm: " text-xs px-3 py-1",
  md: " px-3 py-1",
  lg: " text-lg px-4 py-2",
};

export interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  variant?: keyof typeof variants;
  size?: keyof typeof sizes;
  pill?: boolean;
  uppercase?: boolean;
  normal?: boolean;
  shadow?: boolean;
  loading?: boolean;
  confirm?: boolean;
  onConfirm?: (setOpen: React.Dispatch<React.SetStateAction<boolean>>) => void;
  confirmItem?: React.ReactNode;
  confirmTitle?: string;
  icon?: boolean;
  noPadding?: boolean;
  confirmAction?: string;
  confirmType?: "success" | "info" | "danger" | "warning";
  confirmForm?: string;
}

export const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  size = "md",
  children,
  className,
  pill = false,
  uppercase = true,
  normal = false,
  shadow = true,
  loading = false,
  confirm = false,
  confirmItem,
  confirmTitle,
  confirmType,
  confirmAction,
  confirmForm,
  icon = false,
  noPadding = false,
  onConfirm,
  ...props
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  return (
    <>
      <button
        className={clsx(
          loading ? loadingVariants[variant] : variants[variant],
          pill && "rounded-full",
          props.disabled && "opacity-60 cursor-not-allowed",
          uppercase && "uppercase",
          !noPadding && icon && "p-2",
          icon ? "border border-transparent" : sizes[size],
          normal && "font-medium capitalize py-2 px-4",
          shadow && "shadow-lg",
          className,
          "flex font-medium justify-center items-center transition rounded-md truncate",
          loading
            ? "space-x-2 cursor-wait"
            : "focus:ring-2 focus:ring-offset-2 focus:ring-opacity-60 "
        )}
        onClick={(e) => {
          if (confirm) setOpen(true);
          else {
            if (props.onClick) props.onClick(e);
          }
        }}
        {...props}
      >
        {children || "Button"}
      </button>
      <Confirm
        item={confirmItem}
        title={confirmTitle}
        loading={confirmLoading}
        setLoading={setConfirmLoading}
        open={open}
        action={confirmAction}
        type={confirmType}
        setOpen={setOpen}
        form={confirmForm}
        onConfirm={async () => {
          setConfirmLoading(true);
          if (onConfirm) await onConfirm(setOpen);
          setConfirmLoading(false);
        }}
      />
    </>
  );
};
